<template>
  <div class="d-flex flex-column update-container">
    <header class="masthead mb-auto">
       <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container-fluid">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<ul class="navbar-nav ml-auto align-items-center navWithSearch">
					<li class="nav-item">
              <a class="nav-link" href="#" tabindex="-1" aria-disabled="true">
                <img
                  v-bind:src="require(`@/assets/img/${this.n}.png`)"
                  alt
                  height="40px"
                  width="40px"
                  style="vertical-align: top"
                />
              </a>
            </li>
           <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="dropdown01"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                > </a
              >
              <div
                class="dropdown-menu dropdown-menu-right front"
                aria-labelledby="dropdown01"
              >
                <span class="dropdown-menu-arrow"></span>
                <a class="dropdown-item front" href="/#/profile2"> Manage Profile</a>
                <a class="dropdown-item front" href="/#/account">Account</a>
                <a class="dropdown-item front" href="/#/mediaCenter">Help Center</a>
                <a class="dropdown-item pointer front" @click="logout">Sign Out</a>
              </div>
            </li>
					</ul>
				</div>
			</nav>
    </header>
    <section class="py-5 bg-grey200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="card custom-card">
              <div class="card-body">
                <h5 class="text-center text-green mb-3">
                  Update Your Password
                </h5>
                <div class="content row justify-content-center">
                  <div class="form-group input1 col-md-7">
                    <label class="label-text">Old Password</label>
                    <div class="input-group" id="show_hide_password">
                      <input
                        class="form-control"
                        :type="textInputType"
                        @focus="passwordFocus"
                        v-model="password"
                      />
                    </div>
					<label
                      class="text-center pt-2 text-err"
                      v-if="showPasswordValidBlank"
                      > This section can't be blank</label
                    >
                    <label
                      class="forgotPassword text-center pt2 text-green"
                      @click="forgotPassword"
                    >
                      Forgot your password?
                    </label>
                  </div>
                  <div class="form-group input1 col-md-7">
                    <label class="label-text">New Password</label>
                    <div
                      class="input-group align-items-center"
                      id="show_hide_password"
                    >
                      <input
                        class="form-control"
                        type="password"
                        @focus="passwordFocus"
                        v-model="repassword"
                      />
                    </div>
                    <label
                      class="text-center pt-2 text-err"
                      v-if="showPasswordValidBlank1"
                      >Password can't be blank</label
                    >
                    <label class="text-center pt-2 text-err" v-if="showPasswordMismatch"
                      >Old And New password is same</label
                    >
                  </div>
                  <div class="form-group input1 col-md-7">
                    <label class="label-text"> Confirm Password</label>
                    <div
                      class="input-group align-items-center"
                      id="show_hide_password"
                    >
                      <input
                        class="form-control"
                        type="password"
                        @focus="passwordFocus"
                        v-model="repassword1"
                      />
                    </div>
                    <label
                      class="text-center pt-2 text-err"
                      v-if="showPasswordValidBlank2"
                      > Confirm Password can't be blank</label
                    >
                    <label class="text-center pt-2 text-err" v-if="confirmPasswordMismatch">
                      Passwords are Not Matching</label
                    >
                  </div>
                  <div class="form-group input1 col-md-7">
                    <button
                      class="btn btn-lg btn-outline-light ml-lg-4"
                      v-on:click.stop.prevent="updatepassword"
                    >
                      SAVE
                    </button>
                    <button
                      class="btn btn-lg btn-light ml-lg-2"
                      v-on:click.stop.prevent="cancelUpdate"
                    >
                      CANCEL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.content {
  align-content: center !important;
  align-items: center;
  justify-content: center !important;
}

.input1 {
  align-items: center !important;
  padding-left: 4%;
}

.forgotPassword {
  cursor: pointer;
  margin-bottom: 0px;
}

.text-err{
	color: rgba(255, 0, 0, 0.726)
}

.py-5{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
 min-height: 80vh;
}

</style>

<script>
export default {
  name: "updatepassword",
  components: {},
  mounted() {
    window.scroll(0, 0);
  },
  created() {
    this.$store.commit("showPopup", false);
    this.updateFrom = this.$route.params.id;
     this.$store.commit("showdefaultFooter", true);
    this.$store.dispatch("account").then((res) => {
      this.$store.commit("setLoader", true);
     var n =  res.response.profile.metaData.image_id;
      if(n){
         this.n = n 
      } else {
        this.n = this.n
      }
      this.$store.commit("setLoader", false);
    });
  },
  methods: {

userNotLoggedin() {
			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},

logout() {
      this.$store.dispatch("logout").then((res) => {
        if (res == "true") {
          this.$router.push("/");
        }
      });
    },

    cancelUpdate() {
		this.$router.push("/account");
	},

    passwordFocus() {
      this.showPasswordValidBlank = false;
	  this.showPasswordValidBlank1 = false;
	  this.showPasswordValidBlank2 = false;
      this.showPasswordMismatch = false;
	  this.confirmPasswordMismatch =false
    },

    forgotPassword() {
      this.$router.push("/forgotpasswordemail");
    },
    gotoSingin() {
      this.$router.push("/login");
    },

    validatepassword() {
      if (
        this.password == "" ||
        this.repassword == "" ||
        this.repassword1 == ""
      ) {
		  if ( this.password == ""){
        this.showPasswordValidBlank = true;
		  } else if ( this.repassword == ""){
        this.showPasswordValidBlank1 = true;
		  }else if ( this.repassword1 == ""){
        this.showPasswordValidBlank2 = true;
		  }
        return false;
      }
      if (this.password == this.repassword) {
		this.showPasswordMismatch = true;
        return false;
      } 
	  if (this.repassword !== this.repassword1) {
        this.confirmPasswordMismatch = true;
        return false;
      }else {
        return true;
      }
    },
    updatepassword() {
      if (this.validatepassword()) {
      } else {
        return false;
      }
      this.isActive = true;
      this.showupdatepasswordErr = false;
      var self = this;
      if (this.doupdatepassword) {
        var dataToSend = {
          oldPassword: this.password,
          password: this.repassword,
        };
        this.$store.commit("setLoader", true);
        this.$store
          .dispatch("updatepassword", dataToSend)
          .then((res) => {
            this.showupdatepasswordErr = true;
            this.updatepasswordErr = res.message;
            this.$store.commit("setNotification", res.message);
            self.$store.commit("setLoader", false);
            setTimeout(function () {
              self.$store.dispatch("logout").then((res) => {
                if (res == "true") {
                  self.$store.commit("setLoader", false);
                  self.$router.push("/login");
                }
              });
            }, 1000);
          })
          .catch((err) => {
            this.$store.commit("setLoader", false);
            this.showupdatepasswordErr = true;
			 this.password == "" 
             this.repassword == "" 
             this.repassword1 == ""
			this.$store.commit("setNotification", err.response.data.error.message);
            this.updatepasswordErr = err.response.data.error.message;
          });
      }
    },
  },

  data() {
    return {
      updateFrom: "",
      showupdatepasswordErr: false,
      textInputType: "password",
      textInputTypeCnf: "password",
      updatepasswordErr: "",
      isActive: false,
      doupdatepassword: true,
      showPasswordValidBlank: false,
	  showPasswordValidBlank1: false,
	  showPasswordValidBlank2: false,
      showPasswordMismatch: false,
	  confirmPasswordMismatch: false,
      userid: "",
      password: "",
      repassword: "",
      idParamUid: "",
      idParamToken: "",
      bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      repassword1:"",
      n: 0
    };
  },
};
</script>
